import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import type { ProgressResolverParams } from '@/services/resolvers/types'
import { CarrierLookupRoutes } from '@/routes/user/lookup/types'

export const getCarrierLookupDetailsRoutes = (): RouteRecordRaw[] => [
  {
    name: CarrierLookupRoutes.flow,
    path: 'carrier-lookup/bulk-carrier-lookup',
    meta: {
      parent: CarrierLookupRoutes.index,
      tabTitle: 'pageTabTitle.user.services.carrierLookup.flow',
      modules: [AppModule.CarrierLookupSession, AppModule.CarrierLookupImport],
      resolvers: [
        {
          service: 'ProgressResolver',
          params: {
            serviceIds: ['CarrierLookupSessionService'],
          } satisfies ProgressResolverParams,
        },
      ],
    },
    component: () => import('@/components/views/services/carrierLookup/CarrierLookupFlow.vue'),
  },
]
